let screenWidth;
let screenHeight;
const siteBody = document.body;
const siteHeader = document.querySelector('header');
const siteSearch = document.querySelector('.header__search--active');

window.addEventListener('DOMContentLoaded', () => {
    screenWidth = document.body.clientWidth;
    screenHeight = window.innerHeight;
    cssRootVariable(siteBody, screenWidth, '--screen-width');
    cssRootVariable(siteBody, screenHeight, '--screen-height');
    cssRootVariable(siteBody, siteHeader, '--header-height');
    cssRootVariable(siteBody, siteSearch, '--search-height');
});

// * CHECK IF SCREEN RESIZING HAS ENDED
var rtime;
var timeout = false;
var delta = 200;

window.addEventListener('resize', () => {
    rtime = new Date();
    if (timeout === false) {
        timeout = true;
        setTimeout(resizeend, delta);
    }
});

let resizeend = () => {
    if (new Date() - rtime < delta) {
        setTimeout(resizeend, delta);
    } else {
        timeout = false;
        // SCREEN RESIZING ENDS HERE - APPLY CHANGES BELOW
        screenWidth = document.body.clientWidth;
        screenHeight = window.innerHeight;
        cssRootVariable(siteBody, screenHeight, '--screen-height');
        cssRootVariable(siteBody, screenWidth, '--screen-width');
        cssRootVariable(siteBody, siteHeader, '--header-height');
        cssRootVariable(siteBody, siteSearch, '--search-height');
    }
};

// Functions
let cssRootVariable = (scope, target, propertyName) => {
    if (target) {
        var value;
        if (typeof target === 'number') {
            value = target;
        } else {
            value = target.offsetHeight;
        }
        scope.style.setProperty(propertyName, `${value}px`);
    }
};


var wpcf7Elm = document.querySelector( '.wpcf7' );
if(wpcf7Elm){
    wpcf7Elm.addEventListener( 'wpcf7mailsent', async function( ) {
        let cover = document.getElementsByClassName('contact-cover-success')[0]
        cover.style.display = 'block'
        document.body.style.overflow = 'hidden'
        let successMSG = ""
        if(document.documentElement.lang == 'el'){
            successMSG = "Επιτυχία αποστολής!"
        }else{
            successMSG = "Sent successful"
        }
        let banner = await document.querySelector('.sent .wpcf7-response-output');
        banner.style.display = 'flex'
        let title = await document.createElement("h1")
        title.className = 'title-response title__small'
        let titleText = await document.createTextNode(successMSG);
        title.appendChild(titleText);
        banner.appendChild(title);

        banner.addEventListener('click', function(){
            this.style.display = 'none'
            cover.style.display = 'none'
            document.body.style.overflow = 'unset'
        })
    }, false );
}


let bannerRight = document.querySelector(".section__right .section__banner");
let bannerLeft = document.querySelector(".section__left .section__banner");

if (bannerRight && bannerLeft){

    bannerRight.addEventListener("mouseenter", function() {
        bannerRight.parentElement.classList.add('banner--expanded')
        bannerLeft.parentElement.classList.remove('banner--expanded')
    });

    bannerRight.addEventListener("mouseleave", function() {
        bannerRight.parentElement.classList.remove('banner--expanded')
    });


    bannerLeft.addEventListener("mouseenter", function() {
        bannerLeft.parentElement.classList.add('banner--expanded')
        bannerRight.parentElement.classList.remove('banner--expanded')
    });

    bannerLeft.addEventListener("mouseleave", function() {
        bannerLeft.parentElement.classList.remove('banner--expanded')
    });
}
